import { c as _c } from "react/compiler-runtime";
function ShimmerBar(t0) {
  const $ = _c(2);
  const {
    className
  } = t0;
  const t1 = `animate-pulse rounded bg-gray-200 ${className ?? ""}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export default function Loading() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden xl:flex h-10 items-center justify-end border-b border-gray-100 px-6"><div className="flex items-center gap-4"><ShimmerBar className="h-4 w-16" /><ShimmerBar className="h-5 w-5 rounded-full" /><ShimmerBar className="h-5 w-5 rounded-full" /><ShimmerBar className="h-5 w-5 rounded-full" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ShimmerBar className="h-7 md:h-9 w-28 md:w-36 shrink-0" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="fixed left-0 top-[var(--alert-banner-height,0px)] w-full bg-white h-[71px] md:h-[107px] xl:h-[166px] z-[9]">{t0}<div className="mx-auto flex h-[70px] md:h-[106px] xl:h-[125px] max-w-[1280px] items-center justify-between px-6">{t1}<div className="hidden items-center gap-8 xl:flex"><ShimmerBar className="h-4 w-20" /><ShimmerBar className="h-4 w-24" /><ShimmerBar className="h-4 w-16" /><ShimmerBar className="h-4 w-20" /><ShimmerBar className="h-4 w-24" /></div><ShimmerBar className="hidden h-10 w-28 rounded-full xl:block" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}